/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Barkevs -- Event listeners to change price when swatches are hovered
  // Mouseover event: Update the price when hovering a swatch button
  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest('.swatch__button');
    if (!swatch) return;

    const newPrice = swatch.dataset.variantPrice;
    console.log(newPrice)
    if (!newPrice || newPrice == '$0 USD') return;

    const gridItem = swatch.closest('[data-grid-item-id]');
    if (!gridItem) return;

    const priceWrapper = gridItem.querySelector('.new-price');
    if (priceWrapper) {
      // Only update if the price is different
      if (!priceWrapper.dataset.originalPrice) {
        // Store the original price if it's not stored already
        priceWrapper.dataset.originalPrice = priceWrapper.textContent;
      }

      // Update the price with the new one
      priceWrapper.textContent = "From " + newPrice;
    }
  });

  // Mouseout event: Revert the price back to the original one
  document.addEventListener('mouseout', (event) => {
    // const swatch = event.target.closest('.swatch__button');
    const swatch = event.target.closest('.product-item__swatches__holder');
    if (!swatch) return;

    const gridItem = swatch.closest('[data-grid-item-id]');
    if (!gridItem) return;

    const priceWrapper = gridItem.querySelector('.new-price');
    if (priceWrapper && priceWrapper.dataset.originalPrice) {
      // Revert to the original price
      priceWrapper.textContent = priceWrapper.dataset.originalPrice;
    }
  });
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
